export default "__VITE_ASSET__Dshhj5WX__"